import { useQuery } from "@tanstack/react-query";
import { fetchWorkforceMetrics } from "PFApp/booking/services/api";
import { WorkforceMetrics } from "PFApp/booking/types";
import { Filters } from "PFTypes";
import { CalendarRange } from "PFTypes/calendar_range";
import { QueryOptions } from "PFTypes/request_options";

import { workforceMetricsKeys } from "./query_keys";

interface UseWorkforceMetrics {
  calendarRange: CalendarRange;
  filters?: Filters;
  options?: QueryOptions<WorkforceMetrics>;
}

export const useWorkforceMetrics = ({ calendarRange, filters, options = {} }: UseWorkforceMetrics) =>
  useQuery<WorkforceMetrics>(
    workforceMetricsKeys.single(calendarRange, filters),
    async (): Promise<WorkforceMetrics> => {
      const workforce = await fetchWorkforceMetrics({ dateRange: calendarRange, filters });
      return {
        billableUtilization: workforce.meta.totalBillableUtilization,
        totalUtilization: workforce.meta.totalUtilization,
        totalAvailability: {
          availableMinutes: workforce.meta.availableMinutes,
          nominalWorkingMinutes: workforce.meta.nominalWorkingMinutes
        }
      };
    },
    {
      retry: false,
      ...options
    }
  );
